import axios from "axios";
import {usePaging} from "@/modules/reader/book/paging";
import AbstractAnnotations from "@/modules/reader/annotations/AbstractAnnotations";

class PlayPageKaraokeAnnotation extends AbstractAnnotations{

    static get TYPE() {
        return "playPageKaraoke"
    }

    constructor(builder) {

        super();
        const {pageState, setCurrentPage} = usePaging();
        this.annotations.domPos = builder.domPos;

        if (!this.annotationTypes.includes( PlayPageKaraokeAnnotation.TYPE)) {
            this.annotationTypes.push(PlayPageKaraokeAnnotation.TYPE);
        }

        this.annotations.isPlayPageKaraokeBtn = true;

        for (let [key, value] of Object.entries(builder.meta)) {

            if (key === "id") {
                super.setAnnotations({"id": value});
            }
            else if (key === "icon") {
                super.setAnnotations({"iconSrc": value});
            } else if (key === "audioFileRange") {
                //attempt to get the individual filepath
                //e.g. from karaoke/3AU2_27/3AU2_27_p_0-1-2.mp3 to karaoke/3AU2_27/3AU2_27_p_0, araoke/3AU2_27/3AU2_27_p_1 and araoke/3AU2_27/3AU2_27_p_2
                let fileNameRange = value.split(".mp3")[0];
                let lastUnderScorePos = fileNameRange.lastIndexOf("_");
                let fileNameCommonPart = fileNameRange.substr(0, lastUnderScorePos+1);
                let rangePart = fileNameRange.substr(lastUnderScorePos+1);
                let ranges = rangePart.split("-");
                let audioIds = [];

                //we use the filepath as audioId, so that we can match the individual paragraph to play
                for (let range of ranges) {
                    audioIds.push(`${fileNameCommonPart}${range}`);
                }

                super.setAnnotations({"audioIds": audioIds});
            }
        }

    }

}

export default PlayPageKaraokeAnnotation